// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"4ed60695c3200f2cba52","966":"0342f13b023d3a8f14c5"}[chunkId] + ".js";
};